import { mountComponentTag } from '@/mounter'

import DotcomYoutube from './Youtube'

mountComponentTag('youtube', DotcomYoutube)
